import { render, staticRenderFns } from "./DataScreenList.vue?vue&type=template&id=907977ce&scoped=true"
import script from "./DataScreenList.vue?vue&type=script&lang=js"
export * from "./DataScreenList.vue?vue&type=script&lang=js"
import style0 from "./DataScreenList.vue?vue&type=style&index=0&id=907977ce&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907977ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('907977ce')) {
      api.createRecord('907977ce', component.options)
    } else {
      api.reload('907977ce', component.options)
    }
    module.hot.accept("./DataScreenList.vue?vue&type=template&id=907977ce&scoped=true", function () {
      api.rerender('907977ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datav/DataScreenList.vue"
export default component.exports